var BufferView = require('bufferview');
var NetworkEditor = require('networkeditor');
var ServerLogStatusView = require('serverlogstatusview');


var ServerLogView = BufferView.extend({
    className: BufferView.prototype.className + ' server',
    initialize: function (options) {
        this.status = new ServerLogStatusView(options);
        
        this.editorVisible = false;
        this.listenTo(this.model.connection, 'showEdit', this.showEdit);
        
        BufferView.prototype.initialize.apply(this, arguments);
    },
    events: $.extend({}, BufferView.prototype.events, {
        'buttonClick button.edit': 'clickEdit'
    }),
    render: function () {
        BufferView.prototype.render.apply(this, arguments);
        
        this.renderCollapseDisconnects(true);
        // Use wrapper functions so the event args aren't passed along
        this.model.bind('prefChange:expandDisco', function () {
            this.renderCollapseDisconnects();
        }, this);
        
        return this;
    },
    clickEdit: function (e) {
        e.preventDefault();
        this.toggleEdit();
        return false;
    },
    renderCollapseDisconnects: function (initial) {
        var pinBottom;
        if (!initial) {
            pinBottom = this.scroll.isScrolledToBottom();
        }
        $(this.el).toggleClass('expandDisco', !this.model.isCollapsingDisconnects());
        if (!initial) {
            this.scroll.onChange(pinBottom);
        }
        return this;
    },
    renderConnectionStatus: function () {
        $(this.el).toggleClass('loading', this.model.connection.isConnecting());
        $(this.el).toggleClass('failed', this.model.connection.isFailed());
        $(this.el).toggleClass('badRetry', this.model.connection.badRetry());
        return BufferView.prototype.renderConnectionStatus.apply(this, arguments);
    },
    renderConnectionDetails: function () {
        $(this.el).toggleClass('ssl', this.model.connection.isSSL());
        this.status.renderConnectionDetails();
        if (this.editor && !this.isEditorVisible()) {
            this.editor.setConnection(this.model.connection);
            this.editor.setNickname(this.model.connection.getNick());
        }
    },
    makeEditor: function () {
        // Make a network editor
        var idPrefix = "editServer" + this.model.connection.getCid();
        return new NetworkEditor({
            model: this.model,
            session: this.model.session,
            action: _.bind(this.model.connection.edit, this.model.connection),
            callback: _.bind(function (response) {
                if (response.success) {
                    this.hideEdit();
                }
            }, this),
            className: 'addNetworkForm editNetworkForm',
            classPrefix: "addNetwork",
            id: idPrefix + 'Form',
            idPrefix: idPrefix,
            submitLabel: "Save",
            cancel: _.bind(this.hideEdit, this),
            afterSubmit: [
                $('<span class="explanation">').text('Changing your real name or any of the host settings requires a reconnect'),
                $('<input type="hidden" name="cid">').val(this.model.connection.getCid())
            ],
            cellGroups: [
                NetworkEditor.CELL_GROUPS.netname,
                NetworkEditor.CELL_GROUPS.network,
                NetworkEditor.CELL_GROUPS.identity,
                NetworkEditor.CELL_GROUPS.advanced
            ]
        }, this);
    },
    makeSlackOAuthEditor: function () {
        var idPrefix = "editServer" + this.model.connection.getCid();
        return new NetworkEditor({
            model: this.model,
            session: this.model.session,
            action: _.bind(this.model.connection.editName, this.model.connection),
            prepareFormData: _.bind(function (data) {
                return data.netname;
            }),
            callback: _.bind(function (response) {
                if (response.success) {
                    this.hideEdit();
                }
            }, this),
            className: 'addNetworkForm editNetworkForm',
            classPrefix: "addNetwork",
            id: idPrefix + 'Form',
            idPrefix: idPrefix,
            submitLabel: "Save",
            cancel: _.bind(this.hideEdit, this),
            afterSubmit: [
                $('<input type="hidden" name="cid">').val(this.model.connection.getCid())
            ],
            cellGroups: [
                NetworkEditor.CELL_GROUPS.netname
            ]
        }, this);
    },
    initEditor: function () {
        if (this.editor) {
            this.editor.remove();
            this.editorOverlay.remove();
        }
        if (this.model.connection.isSlackOAuth()) {
            this.editor = this.makeSlackOAuthEditor();
        } else {
            this.editor = this.makeEditor();
        }
        this.editorOverlay = $('<div class="editNetworkOverlay">').append(this.editor.render().el);
        this.$('div.viewport').append(this.editorOverlay);
        this.editor.renderSelectComplete($(this.el));
    },
    postrender: function () {
        this.initEditor();
        this.renderConnectionDetails();
        this.listenTo(this.model.connection, 'change:slack', this.initEditor);
        this.listenTo(this.model.connection, 'change', this.renderConnectionDetails);
    },
    toggleEdit: function () {
        if (this.isEditorVisible()) {
            this.hideEdit();
        } else {
            this.showEdit();
        }
    },
    isEditorVisible: function () {
        return this.editorVisible;
    },
    showEdit: function (withAdvanced, focusInput) {
        if (!this.isEditorVisible()) {
            if (this.editor) {
                this.editor.triggerLoad();
                this.editorOverlay.slideDown('fast', _.bind(function () {
                    if (withAdvanced) {
                        this.editor.toggleCollapsed('Advanced');
                    }
                    if (focusInput) {
                        this.editor.focusInput(focusInput);
                    } else if (this.model.connection.isSlackOAuth()) {
                        this.editor.focusNetname();
                    } else {
                        this.editor.focusNetwork();
                    }
                }, this));
            }
            this.editorVisible = true;
            this.mainTopChange();
        }
    },
    hideEdit: function () {
        if (this.isEditorVisible()) {
            if (this.editor) {
                this.editorOverlay.slideUp('fast');
            }
            this.editorVisible = false;
            this.mainTopChange();
        }
    }
});


module.exports = ServerLogView;



//////////////////
// WEBPACK FOOTER
// ./app/src/view/model/serverlogview.js
// module id = E+Fz
// module chunks = 1